export { default } from './Pill';
export type { PillProps } from './Pill';
